import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import PageOutOfBoundsMessage from '~/modules/common/components/ListTable/PageOutOfBoundsMessage';

const usePageOutOfBoundsMessageStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[100]
  }
}));

const DrilldownTableOutOfBoundsRow = ({
  columns,
  currentPage,
  setCurrentPage
}) => {
  const pageOutOfBoundsMessageClasses = usePageOutOfBoundsMessageStyles();

  return (
    <TableRow>
      <TableCell colSpan={columns.length}>
        <PageOutOfBoundsMessage
          classes={pageOutOfBoundsMessageClasses}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </TableCell>
    </TableRow>
  );
};

DrilldownTableOutOfBoundsRow.propTypes = {
  columns: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired
};

export default DrilldownTableOutOfBoundsRow;
